var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusPaidPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000006257"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#3AB54A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 77",
    d: "M6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632142 7.5913 3.09837e-07 6 0L6 6L6 12Z",
    fill: "#FFE296"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPaidPending);
export default __webpack_public_path__ + "static/media/status-paid-pending.b7b357dd2fc88bd2d9ffa2c0673bdefd.svg";
export { ForwardRef as ReactComponent };